/** ==== PUBLIC ==== **/
// User
export const SET_LOGIN = "SET_LOGIN";
export const USER_IS_ADMIN = "USER_IS_ADMIN";
export const USER_FORGOT_ONE = "USER_FORGOT_ONE";
export const USER_FORGOT_TWO = "USER_FORGOT_TWO";
export const USER_SAVE = "USER_SAVE";
export const USER_DELETE = "USER_DELETE";
export const USER_DETAILS = "USER_DETAILS";
export const USER_IP = "USER_IP";

// Gallerie
export const GAL_LIST = "GAL_LIST";
export const GAL_DETAILS = "GAL_DETAILS";
export const GAL_SAVE = "GAL_SAVE";
export const GAL_DEL = "GAL_DEL";
export const GAL_LIKE = "GAL_LIKE";

// Contact
export const CONT_SEND = "CONT_SEND";
export const CONT_COORD = "CONT_COORD";
export const CONT_SEND_ADMIN = "CONT_SEND_ADMIN";
export const CONT_LIST = "CONT_LIST";
export const CONT_LIST_ADMIN = "CONST_LIST_ADMIN";
export const CONT_HOME_ADMIN = "CONST_HOME_ADMIN";
export const CONT_NBREAD = "CONT_NBREAD";
export const CONT_NBREAD_ADMIN = "CONT_NBREAD_ADMIN";
export const NEWS_SAVE = "NEWS_SAVE";
export const NEWS_SEND = "NEWS_SEND";
export const NEWS_NB = "NEWS_NB";

// Actualités
export const ACTU_SAVE = "ACTU_SAVE";
export const ACTU_DETAILS = "ACTU_DETAILS";
export const ACTU_DEL = "ACTU_DEL";
export const ACTU_LIST = "ACTU_LIST";
export const ACTU_LIKE = "ACTU_LIKE";
export const ACTU_VIEW = "ACTU_VIEW";

// Temps d'attente
export const WAIT_SET = "WAIT_SET";
export const WAIT_GET = "WAIT_GET";
export const WAIT_HISTO = "WAIT_HISTO";
export const WAIT_FILT = "WAIT_FILT";

// Identité
export const IDTT_SET = "IDTT_SET";
export const IDTT_GET = "IDTT_GET";

// Waitime - Rides
export const RIDE_LIST = "RIDE_LIST";
export const RIDE_LIST_PARC = "RIDE_LIST_PARC";
export const RIDE_DET = "RIDE_DET";
export const RIDE_SAVE = "RIDE_SAVE";
export const RIDE_DEL = "RIDE_DEL";
export const RIDE_QUEUE = "RIDE_QUEUE";
export const RIDE_ACT = "RIDE_ACT";
export const RIDE_ENABLE = "RIDE_ENABLE";

// Waitime - Parcs
export const PARC_LIST = "PARC_LIST";
export const PARC_DET = "PARC_DET";
export const PARC_SAVE = "PARC_SAVE";
export const PARC_DEL = "PARC_DEL";
export const PARC_ACT = "PARC_ACT";
export const PARC_ENABLE = "PARC_ENABLE";

// ============ CODE ==============
// Project
export const CODE_PR_LIST = "CODE_PR_LIST";
export const CODE_PR_DET = "CODE_PR_DET";
export const CODE_PR_SAVE = "CODE_PR_SAVE";
export const CODE_PR_DEL = "CODE_PR_DEL";

// Dossiers
export const CODE_FOLD_LIST = "CODE_FOLD_LIST";
export const CODE_FOLD_DET = "CODE_FOLD_DET";
export const CODE_FOLD_SAVE = "CODE_FOLD_SAVE";
export const CODE_FOLD_DEL = "CODE_FOLD_DEL";

// Fichiers
export const CODE_FILE_DET = "CODE_FILE_DET";
export const CODE_FILE_SAVE = "CODE_FILE_SAVE";
export const CODE_FILE_DEL = "CODE_FILE_DEL";